import React from "react";
import Reveal from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../mock";

const Faq = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#FAF8F3] py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Frequently Asked
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            Questions, <span className="gold-text italic">answered</span>
          </h2>
        </Reveal>
        <Reveal className="mt-14" delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#B88A3B]/20"
              >
                <AccordionTrigger className="font-serif-lux text-xl md:text-2xl font-normal text-left hover:text-[#B88A3B] hover:no-underline py-7 [&>svg]:text-[#B88A3B]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#18324F]/70 leading-relaxed pb-8 max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
